export function base64ToBytes(base64) {
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(base64)) {
        console.error("Invalid Base64 string");
        return null;
    }
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
    return new TextDecoder().decode(bytes);
}